<template>
  <div class="dn-table">
    <div v-if="busy" class="dn-table__busy">
      <slot name="table-busy">
        <LoadingSpinner />
      </slot>
    </div>
    <table v-else class="dn-table__table">
      <thead>
        <tr>
          <th
            v-for="field in fields"
            :key="field.key"
            @click="field.sortable ? sort(field.key) : null"
            :class="[
              'dn-table__th',
              field.sortable ? 'dn-table__th--sortable' : '',
              sortKey === field.key ? 'dn-table__th--sorted' : ''
            ]"
          >
            <slot :name="`HEAD_${field.key}`">
              {{ field.label }}
            </slot>
            <span v-if="field.sortable">
              <span v-if="sortKey === field.key">
                {{ sortDesc ? "▼" : "▲" }}
              </span>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="filteredItems.length === 0">
          <td :colspan="fields.length" class="dn-table__empty">
            {{ emptyText }}
          </td>
        </tr>
       <tr v-for="(item, idx) in pagedItems" :key="idx">
          <td v-for="field in fields" :key="field.key" class="dn-table__td">
            <slot :name="field.key" :row="{ item }" :index="idx">
              <!-- Improved datetime detection and formatting -->
              <template v-if="field.type === 'datetime' || field?.formatter === 'formatDateTime'">
                {{ formatDateTime(getValueByPath(item, field.key)) }}
              </template>
              <template v-else>
                {{ getValueByPath(item, field.key) }}
              </template>
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showPagination" class="dn-table__pagination">
      <button :disabled="currentPageInternal === 1" @click="currentPageInternal--">Prev</button>
      <span>Page</span>
      <select v-model="currentPageInternal" class="dn-table__page-selector">
        <option v-for="n in totalPages" :key="n" :value="n">{{ n }}</option>
      </select>
      <span>/ {{ totalPages }}</span>
      <button :disabled="currentPageInternal === totalPages" @click="currentPageInternal++">Next</button>
    </div>
  </div>
</template>

<script lang="ts">
import DnTable from './DnTable.ts';
import { LoadingSpinner } from '../index.js';
export default {
  ...DnTable,
  components: {
    ...(DnTable.components || {}),
    LoadingSpinner,
  },
};
</script>
<style lang="scss" src="./DnTable.scss"></style>